<div id="payments" class="page-layout simple fullwidth" perfect-scrollbar>
  <!-- HEADER -->
  <!-- <div class="header mat-accent-bg p-12 p-sm-24 thin-header" fxLayout="row" fxLayoutAlign="start start" fxLayout.gt-xs="row"
    fxLayoutAlign.gt-xs="row">



    <div fxFlex="" fxLayoutAlign="start center">
      <mat-icon class="logo-icon" *eguardIfOnDom>payment</mat-icon>&nbsp;&nbsp;
      <span class="logo-text h1">Payments </span>
    </div>

    <div fxFlex fxLayoutAlign="end center">

    </div>

  </div> -->
  <!-- / HEADER -->
  <!-- CONTENT -->
  <mat-progress-bar *ngIf="showPaymentsLoader" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <div class="content p-24">

    <div class="table-header">
      <mat-form-field style="padding: 10px 20px 0px;">
        <input matInput type="text" [(ngModel)]="inputValue" (keyup)="applyFilter($event.target.value)" placeholder="Search">
        <mat-icon matPrefix>search</mat-icon>
        <mat-icon *ngIf="inputValue.length > 1" matSuffix (click)="inputValue=''" style="cursor: pointer;">close</mat-icon>
      </mat-form-field>
    </div>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="rows">
        <ng-container matColumnDef="time">
          <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.time | date:'MM/dd/yyyy h:mm a'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="caseid">
          <mat-header-cell *matHeaderCellDef> Case Number </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-button color="accent" (click)="openCase(element.caseid)" *ngIf="element.caseid">
              {{element.caseNumber || open}}
            </button>
            <button mat-button color="accent" routerLink='/cases' *ngIf="!element.caseid">
              UnAssigned 
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ward_name">
          <mat-header-cell *matHeaderCellDef> Ward name </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.ward_name }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef>Paid by</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.user}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{centsToDollars(element.amount)}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{getPaymentStatus(element.transaction_status)}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="mode">
          <mat-header-cell *matHeaderCellDef>Payment Mode</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.online ? 'Online' : 'Offline'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.description}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" [showFirstLastButtons]="true">
      </mat-paginator>
    </div>


  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/payments/payments.component.html